import React, { useEffect, useRef, useState } from "react";
import { useEventContext } from "../../../context/EventContext";
import { CountUp } from "use-count-up";
import useMobile from "../../../hooks/useMobile";
import useTab from "../../../hooks/useTab";

const Count = (props: {Title: string, memberCount: number, countryCount: number}) => {
  const { eventData } = useEventContext();
  const [startCount, setStartCount] = useState(false);
  const counterRef = useRef<HTMLUListElement>(null);
  const mobile = useMobile();
    const tab = useTab();
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setStartCount(true);
        }
      },
      { threshold: 0.1 }
    );

    if (counterRef.current) {
      observer.observe(counterRef.current);
    }

    return () => observer.disconnect();
  }, []);
  return (
    <section
      className="events-page"
      style={{
        padding: "0px 0px 20px 0px",
        // marginTop: (!mobile && !tab) ? "88px" : "unset",
        marginLeft: (!mobile && !tab) ? "240px": "unset", 
      }}
    >
      <div className="container">
        <div
          className="section-title custom-text-center"
          style={{ marginBottom: "unset" }}
        >
          <h2 className="section-title__title custom-user-section-title">{props.Title}</h2>
        </div>
        <div className="col-xl-12 col-lg-12">
          <div>
            <ul
              ref={counterRef}
              className="we-change__counter list-unstyled"
              style={{
                display: "flex",
                justifyContent: "space-around",
                flexWrap: "wrap",
              }}
            >
              <li
                className="we-change__counter-single custom-we-change__counter-single wow fadeInUp"
                data-wow-delay="100ms"
                style={mobile ? {width: '100%'} : {}}
              >
                <div className={`we-change__counter-icon ${mobile && 'custom-we-change__counter-icon'}`}>
                  <span className="icon-stethoscope"></span>
                </div>
                <div className={`we-change__counter-content ${mobile && 'custom-we-change__counter-content'}`}>
                  <h3 className="odometer">
                    <CountUp isCounting={startCount} end={props?.memberCount} duration={3} />
                  </h3>
                  <p className="we-change__counter-text custom-we-change__counter-text">
                    Total {props?.memberCount > 1 ? 'Members' : 'Member'}
                  </p>
                </div>
              </li>
              <li
                className="we-change__counter-single custom-we-change__counter-single wow fadeInUp"
                data-wow-delay="200ms"
                style={mobile ? {width: '100%'} : {}}
              >
                <div className={`we-change__counter-icon we-change__counter-icon-clr-extra ${mobile && 'custom-we-change__counter-icon'}`}>
                  <span className="icon-peace-1"></span>
                </div>
                <div className={`we-change__counter-content ${mobile && 'custom-we-change__counter-content'}`}>
                  <h3 className="odometer">
                    <CountUp isCounting={startCount} end={props?.countryCount} duration={3} />
                  </h3>
                  <p className="we-change__counter-text custom-we-change__counter-text">
                    Total Member {props?.countryCount > 1 ? 'Countries' : 'Country'}
                  </p>
                </div>
              </li>
              <li
                className="we-change__counter-single custom-we-change__counter-single wow fadeInUp"
                data-wow-delay="300ms"
                style={mobile ? {width: '100%'} : {}}
              >
                <div className={`we-change__counter-icon we-change__counter-icon-clr-secondary ${mobile && 'custom-we-change__counter-icon'}`}>
                  <span className="icon-campaign"></span>
                </div>
                <div className={`we-change__counter-content ${mobile && 'custom-we-change__counter-content'}`}>
                  <h3 className="odometer">
                    <CountUp
                      isCounting={startCount}
                      end={eventData?.length}
                      duration={3}
                    />
                  </h3>
                  <p className="we-change__counter-text custom-we-change__counter-text">
                    Total {eventData?.length > 1 ? 'Events' : 'Event'}
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Count;
